import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const copy = {
  heading: `Retail companies build winning customer experiences with Segment`,
}

const logos = [
  carouselLogos.STYLEPIT,
  carouselLogos.PELETON,
  carouselLogos.FOX,
  carouselLogos.GLOSSIER,
  carouselLogos.RAKUTEN,
  carouselLogos.TRADESY,
  carouselLogos.ME_UNDIES,
  carouselLogos.BONOBOS,
  carouselLogos.THE_SKIMM,
  carouselLogos.IBM,
  carouselLogos.FENDER,
  carouselLogos.INSTACART,
  carouselLogos.TRIVAGO,
  carouselLogos.LEVIS,
]

const LogoCarouselComponent = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <LogoCarousel heading={copy.heading} logos={logos} />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 10px;
    padding-bottom: 0;

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 40px;
    }
  }
`

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default LogoCarouselComponent
